<template>
  <v-form v-model="valid" ref="customerind">
    <v-row class="ms-1 me-1 mt-2" justify="start">
      <v-col cols="12" md="4">
        <label class="my-0 labelFontsize required">Benificiary Country</label>
        <v-autocomplete
          placeholder="Benificiary Country"
          required
          class="rounded"
          outlined
          dense
          item-text="txt"
          item-value="val"
          :items="country_options"
          :rules="BeneCountryRules"
          v-model="beneficiaryReqBody.country_code"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="4">
        <label class="my-0 labelFontsize required">Payment Method</label>
        <v-autocomplete
          placeholder="Payment Method"
          required
          class="rounded"
          outlined
          dense
          item-text="txt"
          item-value="val"
          :items="method_options"
          :rules="Paymentmethod"
          v-model="beneficiaryReqBody.payment_code"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="4" v-if="beneficiaryReqBody.payment_code === 'B'">
        <label class="my-0 labelFontsize required">Bank Name</label>
        <v-autocomplete
          placeholder="Bank Name"
          required
          class="rounded"
          outlined
          dense
          item-text="txt"
          item-value="val"
          :items="payment_location"
          :rules="Bankname"
          v-model="beneficiaryReqBody.location_id"
        ></v-autocomplete>
      </v-col>

      <v-col cols="12" md="4" v-if="beneficiaryReqBody.payment_code === 'B'">
        <label class="my-0 labelFontsize"
          >Branch Code
          <span
            class="required"
            v-if="this.beneficiaryReqBody.country_code === 'IND'"
            >(ifsc code:
            <a href="https://www.ifsccodebank.com/" target="_blank"
              >www.ifsccodebank.com</a
            >
            )</span
          >
        </label>
        <v-text-field
          v-if="this.beneficiaryReqBody.country_code === 'IND'"
          placeholder="Branch Code"
          required
          class="rounded"
          outlined
          dense
          :rules="ifscrules"
          v-model="beneficiaryReqBody.branch_code"
        ></v-text-field>
        <v-text-field
          v-else
          placeholder="Branch Code"
          required
          class="rounded"
          outlined
          dense
          v-model="beneficiaryReqBody.branch_code"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="4" v-if="beneficiaryReqBody.payment_code === 'B'">
        <label class="my-0 labelFontsize required">Account Number</label>
        <v-text-field
          placeholder="Account Number"
          required
          class="rounded"
          outlined
          dense
          :rules="accountrules"
          v-model="beneficiaryReqBody.bank_account_no"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="4" v-if="beneficiaryReqBody.payment_code != 'B'">
        <label class="my-0 labelFontsize required">Payment Location</label>
        <v-autocomplete
          placeholder="Payment Location"
          required
          class="rounded"
          outlined
          dense
          item-text="txt"
          item-value="val"
          :items="payment_location"
          :rule="Paymentloction"
          v-model="beneficiaryReqBody.location_id"
        ></v-autocomplete>
      </v-col>

      <v-col cols="12" md="4">
        <label class="my-0 labelFontsize required">First Name</label>
        <v-text-field
          placeholder="First Name"
          required
          class="rounded"
          outlined
          dense
          :rules="firstnameValidations"
          v-model="beneficiaryReqBody.first_name"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="4">
        <label class="my-0 labelFontsize required">Last Name</label>
        <v-text-field
          placeholder="Last Name"
          required
          class="rounded"
          outlined
          dense
          :rules="lastnameValidations"
          v-model="beneficiaryReqBody.last_name"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="4">
        <label class="my-0 labelFontsize required">Relationship</label>
        <v-autocomplete
          placeholder="Relationship"
          required
          class="rounded"
          outlined
          dense
          item-text="txt"
          item-value="val"
          :rules="Relationship"
          :items="relation_options"
          v-model="beneficiaryReqBody.relationship_code"
        ></v-autocomplete>
      </v-col>

      <v-col cols="12" md="4">
        <label class="my-0 labelFontsize required">Contact Number </label>
        <vue-phone-number-input
          class="rounded"
          required
          default-country-code="MY"
          @update="onChangeNumber($event)"
        
          v-model="beneficiaryReqBody.phone_number"
        />
      </v-col>
      <v-col cols="12" md="4">
        <label class="my-0 labelFontsize required">E-mail</label>
        <v-text-field
          placeholder="E-mail"
          required
          class="rounded"
          outlined
          dense
          :rules="emailValidations"
          v-model="beneficiaryReqBody.email_id"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="4">
        <label class="my-0 labelFontsize">Address</label>
        <v-text-field
          placeholder="Address"
          required
          class="rounded"
          outlined
          dense
          v-model="beneficiaryReqBody.address"
        ></v-text-field>
      </v-col>

      <v-col cols="12" md="4">
        <label class="my-0 labelFontsize required">Native Country</label>
        <v-autocomplete
          placeholder="Native Country"
          required
          class="rounded"
          outlined
          dense
          item-text="txt"
          item-value="val"
          @change="onChangeState()"
          :items="country_Option"
          :rules="NativeCountryRules"
          v-model="beneficiaryReqBody.birth_country"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="4" v-if="beneficiaryReqBody.payment_code != 'B'">
        <label class="my-0 labelFontsize">Province</label>
        <v-autocomplete
          placeholder="Province"
          required
          class="rounded"
          outlined
          dense
          item-text="txt"
          item-value="val"
          @change="onChangeCity()"
          :items="state_options"
          v-model="beneficiaryReqBody.state_code"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="4" v-if="beneficiaryReqBody.payment_code != 'B'">
        <label class="my-0 labelFontsize">City</label>
        <v-autocomplete
          v-if="!cityInputEnabled"
          placeholder="City"
          required
          class="rounded"
          outlined
          dense
          item-text="txt"
          item-value="val"
          :items="city_options"
          v-model="beneficiaryReqBody.city_code"
        ></v-autocomplete>
        <v-text-field
          v-else
          placeholder="Enter City"
          class="rounded"
          outlined
          dense
          v-model="beneficiaryReqBody.city_code"
        ></v-text-field>
      </v-col>

      <v-col cols="12" md="4" v-if="beneficiaryReqBody.payment_code != 'B'">
        <label class="my-0 labelFontsize">Postal Code</label>
        <v-text-field
          placeholder="Postal Code"
          required
          class="rounded"
          outlined
          dense
          v-model="beneficiaryReqBody.postal_code"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row class="ms-1 me-1" justify="end">
      <v-col cols="12" md="12" class="mb-2">
        <!-- <router-link :to="'/tab/' + tabIndex" class="text-decoration-none"> -->
        <v-btn depressed 
          color="primary"
          class="float-right mb-3 text-capitalize"
          small
          @click="onSubmitFor()"
        >
        <v-icon small class="me-2">mdi-content-save-check-outline</v-icon>{{ $route.query.receiver_id ? "Update" : "Submit" }}
        </v-btn>
        <!-- </router-link>
        <router-view /> -->

        <v-btn depressed 
          class="mr-2 float-right text-capitalize"
          color="primary"
          outlined
          small
          @click="cancel()"
        >
        <v-icon small class="me-2">mdi-close-circle-outline</v-icon>cancel
        </v-btn>
      </v-col>
    </v-row>
    <loading :active="loader" :opacity="0.9" color="#ff6b00" />
  </v-form>
</template>

<script>
import { Beneficiaryvali } from "@/utils/validationCopy.js";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import alerts from "@/mixins/alerts";
import Loading from "vue-loading-overlay";
import commonService from "@/services/CommonService/commonService.js";
import remmitenceService from "@/services/RemitteService/remitteService.js";
export default {
  mixins: [alerts],
  data: () => ({
    ...Beneficiaryvali,
    isValidNumber: false,
    valid: true,
    loader: false,
    // tabIndex: 1,
    relation_options: [],
    city_options: [],
    cityInputEnabled: false,
    state_options: [],
    country_Option: [],
    country_options: [],
    method_options: [],
    payment_location: [],
    beneficiaryReqBody: {
      rec_type: "IND",
      country_name: "",
      country_code: "",
      currency_code: "",
      payment_code: "",
      branch_id: 0,
      bank_id: 0,
      bank_account_no: "",
      location_id: "",
      location_name: "",
      first_name: "",
      middle_name: "",
      last_name: "",
      relationship_code: "",
      phone_number: "",
      address: "",
      state_code: "",
      city_code: "",
      postal_code: "",
      email_id: "",
      branch_code: "",
      birth_country: "",
    },
    ifscrules: [
      (v) => !!v || "Branch Code is required",
      (v) =>
        /^[a-zA-Z0-9]{0,11}$/.test(v) ||
        "Branch Code must be alphanumeric and up to 11 digits",
    ],
  }),
  components: {
    VuePhoneNumberInput,
    Loading,
  },
  watch: {
    "beneficiaryReqBody.location_id"(value) {
      console.log(value);
      if (value) {
        const location_obj = this.payment_location.find(
          (ele) => ele.val === this.beneficiaryReqBody.location_id
        );
        console.log(location_obj);
        if (location_obj) {
          this.beneficiaryReqBody.location_name = location_obj.txt;
        }
      }
    },
    "beneficiaryReqBody.country_code"(value) {
      // alert(value);
      if (this.beneficiaryReqBody.country_code) {
        // Make API call
        this.getPaymentMode();
        this.getpayLocation(this.beneficiaryReqBody.payment_code, value);
      }
    },
    "beneficiaryReqBody.payment_code"(value) {
      console.log(value);
      this.getpayLocation(value, this.beneficiaryReqBody.country_code);
      // if (value === "B") {
      //   // Make API call

      // }
    },
  },
  created() {
    this.editpage();
  },
  mounted() {
    this.getBeneCountryList();
    this.getRelationship();
    this.getCountryies();
    // this.getPaymentMode();
    // this.getpayLocation();
    console.log(this.$route.query.receiver_id);
    console.log(this.$route.query.customer_id);
    if (!this.$route.query.receiver_id) {
      this.beneficiaryReqBody.payment_code = "B";
    }
  },
  methods: {
    onSubmitFor() {
      if (this.$route.query.receiver_id) {
        console.log("details");
        this.update();
      } else {
        console.log("else");
        this.saveData();
        // console.log('update')
      }
    },
    onChangeNumber(e) {
      console.log("e", e);
      this.isValidNumber = e.isValid;
      this.beneficiaryReqBody.phone_number = e.countryCode;
    },
    cancel() {
      this.$refs.customerind.resetValidation();
    },
    async saveData() {
      const validate = this.$refs.customerind.validate();
      if (validate) {
        this.loader = true;
        try {
        const responseData = await remmitenceService.saveBenificiaryData(sessionStorage.getItem("Benecustomer_id"),this.beneficiaryReqBody);
        if (responseData.data.status_code === 200) {
          this.showAlertSuccess(responseData.data.message);
          window.history.back();
          this.loader = false;
        } 
        // else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.saveData();
        // }
        else {
          this.showAlertError(responseData.data.message);
        }
        this.cancel();
        console.log("save response", responseData);
      } catch (e) {
        console.error(e);
        this.loader = false;
        this.showAlertError("Something went wrong please try again later.");
      }
      }
    },

    async update() {
      console.log(`basicDetails: ${JSON.stringify(this.basicDetails)}`);
      // alert('i am hitted')
      this.loader = true;
      try {
        const responseData = await remmitenceService.updateBenificiaryData( this.$route.query.receiver_id,sessionStorage.getItem("addBeneInd"),this.beneficiaryReqBody);
        if (responseData.data.status_code === 200) {
          this.showAlertSuccess(responseData.data.message);
          window.history.back();
          this.loader = false;
        } 
        // else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.update();
        // }
        else {
          this.showAlertError(responseData.data.message);
        }
        this.cancel();
        console.log("update response", responseData);
      } catch (e) {
        console.error(e);
        this.loader = false;
        this.showAlertError("Something went wrong please try again later.");
      }
      
    },
   async editpage() {
      this.loader = true;
      const routerDataItem = this.$route.query.receiver_id;
      if (routerDataItem) {
        try {
        const responseData = await remmitenceService.editBenificiaryData(routerDataItem,this.$route.query.customer_id);
        if (responseData.data.status_code === 200) {
          this.beneuserList = responseData.data.data[0];
          this.loader = false;
          console.log(" this.beneuserList", this.beneuserList);
        }
        //  else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.update();
        // }
        else {
          this.showAlertError(responseData.data.message);
        }
        this.beneficiaryReqBody = responseData.data.data[0];
        this.getRelationship();
        
      } catch (e) {
        console.error(e);
        this.loader = false;
        this.showAlertError("Something went wrong please try again later.");
      }
      } else {
        console.log("beneficiaryReqBody");
        this.beneficiaryReqBody = {
          rec_type: "IND",
          country_name: "",
          country_code: "",
          currency_code: "",
          payment_code: "",
          branch_id: 0,
          bank_id: 0,
          bank_account_no: "",
          location_id: "",
          location_name: "",
          first_name: "",
          middle_name: "",
          last_name: "",
          relationship_code: "",
          phone_number: "",
          address: "",
          state_code: "",
          city_code: "",
          postal_code: "",
          email_id: "",
          branch_code: "",
          birth_country: "",
        };
      }
    },

    async getBeneCountryList() {
      this.loader = true;
      try {
        const responseData = await commonService.getBeneficiaryCountryList();
        this.loader = false;
        if (responseData.data.status_code === 200) {
          this.country_options = responseData.data.data.map((i) => {
            return {
              txt: i.name,
              val: i.isoAlpha3,
            };
          });
          //Maping data while updateing beneficiary
          if (
            this.$route.query.receiver_id &&
            this.beneuserList.country_code.iso_alpha3
          ) {
            this.beneficiaryReqBody.country_code =
              this.beneuserList.country_code.iso_alpha3;
          } else {
            this.beneficiaryReqBody.country_code = "IND";
          }
          console.log("country_obj", this.country_options);
        } 
        // else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getBeneCountryList();
        // }
        console.log("getBeneCountryList", responseData);
      } catch (e) {
        this.loader = false;
        console.error(e);
      }
    },
    async getPaymentMode() {
      this.loader = true;
      try {
        const responseData = await commonService.getPaymentmode(
          this.beneficiaryReqBody.country_code
        );
        this.loader = false;
        if (responseData.data.status_code === 200) {
          this.method_options = responseData.data.data.map((i) => {
            return {
              txt: i.payment_mode,
              val: i.payment_mode_code,
            };
          });

          if (
            this.$route.query.receiver_id &&
            this.beneuserList.payment_code.payment_mode_code
          ) {
            // alert("i am hitted");
            this.beneficiaryReqBody.payment_code =
              this.beneuserList.payment_code.payment_mode_code;
          }
          console.log("country_obj", this.country_options);
        } 
        // else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getPaymentMode();
        // }
        console.log("getPaymentMode", responseData);
      } catch (e) {
        this.loader = false;
        console.error(e);
      }
    },
    async getpayLocation(payment_code, selectedCountry) {
      this.loader = true;
      try {
        const responseData = await commonService.getPayLocate(
          payment_code,
          selectedCountry,
          sessionStorage.getItem("addBeneInd")
        );
        this.loader = false;
        if (responseData.data.status_code === 200) {
          this.payment_location = responseData.data.data.map((i) => {
            return {
              txt: i.locationName,
              val: i.locationId,
            };
          });
          console.log("this.payment_location", this.payment_location);
          console.log(this.beneficiaryReqBody.payment_mode);

          if (
            this.$route.query.receiver_id &&
            this.beneuserList.payment_code.payment_mode_code
          ) {
            // alert("i am hitted");
            this.beneficiaryReqBody.payment_code =
              this.beneuserList.payment_code.payment_mode_code;
          }
          console.log("country_obj", this.country_options);
        } 
        // else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getpayLocation(payment_code, selectedCountry);
        // }
        console.log("getpayLocation", responseData);
      } catch (e) {
        this.loader = false;
        console.error(e);
      }
    },
    async getRelationship() {
      this.loader = true;
      try {
        const responseData = await commonService.getRelationships();
        this.loader = false;
        if (responseData.data.status_code === 200) {
          this.relation_options = responseData.data.data.map((i) => {
            return {
              txt: i.value,
              val: i.value_code,
            };
          });
          if (
            this.$route.query.receiver_id &&
            this.beneuserList.relationship_code.value_code
          ) {
            this.beneficiaryReqBody.relationship_code =
              this.beneuserList.relationship_code.value_code;
          }
          // console.log( 'this.relation_options', this.relation_options)

          console.log(this.beneficiaryReqBody.payment_mode);
        } 
        // else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getRelationship();
        // }
        console.log("getRelationship", responseData);
      } catch (e) {
        this.loader = false;
        console.error(e);
      }
    },
    async getCountryies() {
      this.loader = true;
      try {
        const responseData = await commonService.getCountryBirthList();
        this.loader = false;
        if (responseData.data.status_code === 200) {
          this.country_Option = responseData.data.data.map((i) => {
            return {
              txt: i.country_name,
              val: i.iso_alpha3,
            };
          });
        } 
        // else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getCountryies();
        // }
        console.log("getCountryies", responseData);
      } catch (e) {
        this.loader = false;
        console.error(e);
      }
    },
    async onChangeState() {
      this.loader = true;
      try {
        const responseData = await commonService.getStatesList(
          this.beneficiaryReqBody.birth_country
        );
        if (responseData.data.status_code === 200) {
          this.state_options = responseData.data.data.map((i) => {
            return {
              txt: i.name,
              val: i.state_code,
            };
          });
          this.loader = false;
        }
        //  else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.onChangeState();
        // }
        console.log("States", responseData);
      } catch (e) {
        console.error(e);
        this.loader = false;
      }
    },
    async onChangeCity() {
      this.loader = true;
      this.beneficiaryReqBody.city_code = "";
      this.city_options = [];
      this.cityInputEnabled = false;
      try {
        const responseData = await commonService.getCitiesList(
          this.beneficiaryReqBody.birth_country,
          this.beneficiaryReqBody.state_code
        );
        if (responseData.data.status_code === 200) {
          this.city_options = responseData.data.data.map((i) => {
            return {
              txt: i.name,
              val: i.id,
            };
          });
          this.cityInputEnabled = this.city_options.length === 0;
          this.loader = false;
        } 
        // else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.onChangeCity();
        // }
        console.log("Cities", responseData);
      } catch (e) {
        console.error(e);
        this.loader = false;
      }
    },
  },
};
</script>

<style lang="css">
.required:after {
  content: " *";
  color: red;
}
</style>
